/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BusinessSettingsTreeComponent} from './component/business-settings-tree.component';
import {EntityTreeModule} from '../../../shared/entity-tree/entity-tree.module';
import {LoadingSpinnerModule} from '../../../shared/loading/loading-spinner/loading-spinner.module';
import {UploadConfigurationModule} from './upload-configuration/upload-configuration.module';
import {ConfirmModalModule} from '../../../shared/confirm-modal/confirm-modal/confirm-model.module';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        EntityTreeModule,
        LoadingSpinnerModule,
        UploadConfigurationModule,
        ConfirmModalModule,
        TooltipModule
    ],
    declarations: [BusinessSettingsTreeComponent],
    exports: [BusinessSettingsTreeComponent]
})

export class BusinessSettingsModule {
}

